import { Card, Col, Row } from "react-bootstrap";
import { CompanyEditForm } from "@/components/entities/company/CompanyEditForm";
import { ButtonLinkBack } from "@/components/lib/ButtonLinkBack";
import { useOutletContext } from "react-router-dom";
import React from "react";

type ContextType = {
  setTitle: React.Dispatch<React.SetStateAction<string>>
}

export const CompanyEdit = () => {
  const { setTitle } = useOutletContext<ContextType>()
  
    React.useEffect(() => {
      setTitle('Sociétés')
    }, [setTitle])
  /* Render
   *******************************************************************************************/
  return (
    <>
      <Row>
        <Col>
          <ButtonLinkBack />
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="col-xl-6 col-lg-10 col-md-12 mx-auto">
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mt-2">Modifier les informations de la société</h5>
            </Card.Header>
            <Card.Body className="p-5">
              <CompanyEditForm />
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </>
  );
};
